import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div
        className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center"
        data-testid="auth-loading"
      >
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-[#00E5FF] border-t-transparent rounded-full animate-spin" />
          <p className="text-zinc-500 text-sm mono uppercase tracking-wider">Overujem prístup…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== "admin") return <Navigate to="/login" replace />;

  return children;
}
